import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

const CancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6 font-['DM_Sans']">
      <div style={{ maxWidth: 450, width: "100%", textAlign: "center", padding: "4rem 0" }}>
        <XCircle data-testid="cancel-icon" style={{ width: 64, height: 64, color: "#999", margin: "0 auto 1.5rem" }} />
        <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: "1.8rem", fontWeight: 700, color: "#1a1a1a", marginBottom: "0.5rem" }}>
          Paiement annulé
        </h2>
        <p style={{ color: "#555", fontSize: "0.95rem", marginBottom: "2.5rem", lineHeight: 1.6 }}>
          Votre réservation n'a pas été confirmée. Aucun montant n'a été débité.
        </p>
        <div style={{ display: "flex", gap: "1rem", justifyContent: "center", flexWrap: "wrap" }}>
          <button
            data-testid="retry-booking-btn"
            onClick={() => navigate("/booking")}
            style={{
              background: "linear-gradient(135deg, #b8977e, #c9a88a)", color: "#fff", border: "none", borderRadius: 50,
              padding: "0.9rem 2rem", fontFamily: "'DM Sans',sans-serif", fontWeight: 600, cursor: "pointer",
              boxShadow: "0 4px 20px rgba(184,151,126,0.3)",
            }}
          >
            Réessayer
          </button>
          <button
            data-testid="back-home-btn"
            onClick={() => navigate("/")}
            style={{
              background: "transparent", color: "#b8977e", border: "1.5px solid #b8977e", borderRadius: 50,
              padding: "0.9rem 2rem", fontFamily: "'DM Sans',sans-serif", fontWeight: 600, cursor: "pointer",
            }}
          >
            Accueil
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelPage;
